import { render, staticRenderFns } from "./TaxInvoiceList.vue?vue&type=template&id=ca2c6468&scoped=true"
import script from "./TaxInvoiceList.vue?vue&type=script&lang=js"
export * from "./TaxInvoiceList.vue?vue&type=script&lang=js"
import style0 from "./TaxInvoiceList.vue?vue&type=style&index=0&id=ca2c6468&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca2c6468",
  null
  
)

export default component.exports